var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.432,
    height: 22.382,
    viewBox: "0 0 34.432 22.382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DE-Flag",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4096",
    "data-name": "Rectangle 4096",
    width: 34.432,
    height: 7.461,
    transform: "translate(0 14.92)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4097",
    "data-name": "Rectangle 4097",
    width: 34.432,
    height: 7.461,
    transform: "translate(0 7.46)",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4098",
    "data-name": "Rectangle 4098",
    width: 34.432,
    height: 7.461,
    transform: "translate(0 -0.001)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeFlag);
export default __webpack_public_path__ + "static/media/DE-Flag.25165f2bf31b87984ca74b5434514bc1.svg";
export { ForwardRef as ReactComponent };